import React from 'react';
import moment from 'moment';

export type NewRequestModalData = {
  chargeAccount: string;
  equipmentCategory: string;
  equipmentType: string;
  notes: string;
  quantity: number;
  status: string;
  id: number;
};

export type NewRequestData = {
  attachments: any;
  covidRelated: any;
  oitStock: any;
  deliveryLocation: string;
  requestorDepartment: any;
  requestorDivision: any;
  fulfillingDepartment?: any;
  fulfillingDivision?: any;
  requestorEmail: string;
  requestorName: string;
  requestorPhoneNumber: string;
};

export const newRequestModalDefaults = {
  chargeAccount: '',
  equipmentCategory: '',
  equipmentType: '',
  notes: '',
  quantity: 1,
  status: 'Requested',
  id: -1,
};

const tmpEditCell = (info) => {
  return (
    <div>
      <a href={`/receiving/view/requestId=${info.getValue()}`}>{info.row.renderValue('requestNumber')}</a>
    </div>
  );
};

const getEditCell = ({ value, row }: any) => {
  if (value != null) {
    let link = '/receiving/view/requestId=' + row.id;
    return (
      <div>
        <a href={link} className='info'>
          {row.requestNumber}
        </a>
      </div>
    );
  } else {
    return '';
  }
};

function editRequestedItem({ value, row }: any) {
  if (value != null) {
    let link = `/receiving/view/requestedItemId=${row.requestedItemId}`;
    return (
      <div style={{ textAlign: 'center' }}>
        <a href={link} className='info'>
          Edit
        </a>
      </div>
    );
  } else {
    return '';
  }
}

function addCovidStatus({ value, row }: any) {
  if (value != null) {
    if (row._original.isCovid === true) {
      return (
        <div>
          <strong>COVID-19 Purchase</strong>
          <br />
          {row._original.equipmentType}
        </div>
      );
    }
    return <div>{row._original.equipmentType}</div>;
  }
}

function editEoRiView({ value, row }: any) {
  if (value != null && row.table === 'E') {
    let link = row.updateType === 'C' ? `/transfers/approval/${row.id}` : `/assets/view/eOneId=${row.id}`;
    return (
      <div style={{ textAlign: 'center' }}>
        <a href={link} className='info'>
          Edit
        </a>
      </div>
    );
  } else if (value != null && row.table === 'R') {
    let link = `/receiving/view/requestedItemId=${row.id}`;
    return (
      <div style={{ textAlign: 'center' }}>
        <a href={link} className='info'>
          Edit
        </a>
      </div>
    );
  } else {
    return '';
  }
}

function editEOneItem({ value, row }: any) {
  if (value != null) {
    let link = row.updateType === 'C' ? `/transfers/approval/${row.updateId}` : `/assets/view/eOneId=${row.updateId}`;
    return (
      <div style={{ textAlign: 'center' }}>
        <a href={link} className='info'>
          Edit
        </a>
      </div>
    );
  } else {
    return '';
  }
}

function combineRequestorInfo({ value, row }: any) {
  if (value != null) {
    return (
      <div>
        {row._original.requestorName}
        <br />
        {row._original.requestorPhoneNumber}
        <br />
        {row._original.requestorEmail}
      </div>
    );
  } else {
    return '';
  }
}

function combineDepartmentInfo({ value, row }: any) {
  if (value != null) {
    if (row._original.requestorDivision !== null || row._original.requestorDivision !== '') {
      return (
        <div>
          {row._original.requestingDepartment}
          <br />
          {row._original.requestorDivision}
        </div>
      );
    } else {
      return <div>{row._original.requestingDepartment}</div>;
    }
  }
  return '';
}

function combineFDepartmentInfo({ value, row }: any) {
  if (value != null) {
    if (row._original.fulfillingDivision !== null || row._original.fulfillingDivision !== '') {
      return (
        <div>
          {row._original.fulfillingDepartmentName}
          <br />
          {row._original.fulfillingDivision}
        </div>
      );
    } else {
      return <div>{row._original.fulfillingDepartmentName}</div>;
    }
  }
  return '';
}

function updateType({ value, row }: any) {
  if (value !== null) {
    switch (row._original.updateType) {
      case 'C':
        return 'Transfer';
      case 'S':
        return 'Salvage';
      case 'A':
        return 'New Item';
      default:
        return 'N/A';
    }
  } else {
    return '';
  }
}

function tableType({ value, row }: any) {
  if (value != null) {
    if (row.table === 'R') {
      return 'Request Item';
    } else {
      switch (row.updateType) {
        case 'C':
          return 'Transfer';
        case 'S':
          return 'Salvage';
        case 'A':
          return 'New Item';
        default:
          return 'N/A';
      }
    }
  } else {
    return '';
  }
}

export function useRhfWatchHook(watch: any, variable: string, defaultValue: number) {
  try {
    const temp = watch(variable, defaultValue);
    if (temp === defaultValue || temp.length === 0) {
      return false;
    }
    return true;
  } catch (e) {
    // not array
    return false;
  }
}

export type FilterButtonFilter = {
  id: string;
  isLike: boolean;
  operand: string;
  type: string;
  value: string;
};

export class FilterButtons {
  title = '';
  variant = '';
  filter = {
    id: '',
    isLike: false,
    operand: '',
    type: '',
    value: '',
  };

  constructor(title: string, variant: string, filter: FilterButtonFilter) {
    this.title = title;
    this.variant = variant;
    this.filter = filter;
  }
}

export const tmpColumns = [
  {
    column: {
      Header: 'Request #',
      accessor: 'id',
      type: 'string',
      width: 70,
      Cell: tmpEditCell,
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      accessor: 'requestNumber',
      show: false,
      resizable: true,
    },
    type: 'string',
    hidden: true,
  },
  {
    column: {
      Header: 'Requestor',
      accessor: 'requestorName',
      type: 'string',
      // Cell: combineRequestorInfo,
      resizable: true,
      width: 175,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Category',
      accessor: 'equipmentCategory',
      width: 70,
      resizable: true,
      type: 'number',
    },
    type: 'number',
  },
];

export const receivingPageColumns = [
  {
    column: {
      Header: 'Request #',
      accessor: 'id',
      type: 'string',
      width: 70,
      Cell: getEditCell,
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      accessor: 'requestNumber',
      show: false,
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Requestor',
      accessor: 'requestorName',
      type: 'string',
      Cell: combineRequestorInfo,
      resizable: true,
      width: 175,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Requesting Dept.',
      accessor: 'requestingDepartment',
      type: 'string',
      width: 200,
      resizable: true,
      style: { whiteSpace: 'unset' },
      Cell: combineDepartmentInfo,
    },
    type: 'string',
  },
  {
    column: {
      accessor: 'requestorDivision',
      show: false,
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Fulfilling Dept.',
      accessor: 'fulfillingDepartmentName',
      type: 'string',
      width: 200,
      collapsible: true,
      resizable: true,
      style: { whiteSpace: 'unset' },
      Cell: combineFDepartmentInfo,
    },
    type: 'string',
  },
  {
    column: {
      accessor: 'fulfillingDivision',
      show: false,
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Category',
      accessor: 'equipmentCategory',
      width: 70,
      resizable: true,
      type: 'number',
    },
    type: 'number',
  },
  {
    column: {
      Header: 'Equipment Type',
      accessor: 'equipmentType',
      width: 300,
      resizable: true,
      type: 'string',
      Cell: addCovidStatus,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Quantity',
      accessor: 'quantity',
      type: 'number',
      resizable: true,
      width: 70,
    },
    type: 'number',
  },
  {
    column: {
      Header: 'Order Number',
      accessor: 'orderNumber',
      type: 'string',
      resizable: true,
      width: 110,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Notes',
      accessor: 'notes',
      type: 'string',
      resizable: true,
      style: { whiteSpace: 'unset' },
    },
    type: 'string',
  },
  {
    column: {
      Header: 'OIT Notes',
      accessor: 'oitNotes',
      type: 'string',
      resizable: true,
      style: { whiteSpace: 'unset' },
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Status',
      accessor: 'status',
      type: 'string',
      resizable: true,
      width: 100,
    },
    type: 'string',
  },
];

export const eoRiViewColumns = [
  {
    column: {
      Header: '',
      accessor: 'id',
      filterable: false,
      resizable: true,
      width: 50,
      Cell: editEoRiView,
    },
    type: 'string',
  },

  {
    column: {
      Header: 'Request FY #',
      resizable: true,
      accessor: 'requestItemFYNumber',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Barcode',
      resizable: true,
      accessor: 'barCode',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      accessor: 'updateType',
      show: false,
      type: 'string'
    }, 
    type: 'string'
  },
  // {
  //   column: {
  //     Header: 'Asset #',
  //     accessor: 'assetNumber',
  //     type: 'string',
  //   },
  //   type: 'string',
  // },
  {
    column: {
      Header: 'Serial Number',
      resizable: true,
      accessor: 'serialNumber',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Department',
      accessor: 'department',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Delivery/Aquired Date',
      resizable: true,
      accessor: 'deldAcqdDate',
      Cell: (props: any) => (props.value == null ? '' : moment(props.value, 'YYYY-MM-DD HH:mm Z').format('MM/DD/YYYY h:mm a')),
    },
    type: 'Date',
  },
  // {
  //   column: {
  //     Header: 'EOne Entry Date',
  //     accessor: 'dateEnteredInEnterpriseOne',
  //     Cell: (props: any) => (props.value == null ? '' : moment(props.value, 'YYYY-MM-DD HH:mm Z').format('MM/DD/YYYY h:mm a')),
  //   },
  //   type: 'Date',
  // },
  {
    column: {
      Header: 'Description 1',
      accessor: 'description1',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 2',
      resizable: true,
      accessor: 'description2',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 3',
      resizable: true,
      accessor: 'description3',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Status',
      resizable: true,
      accessor: 'status',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Item Info',
      accessor: 'table',
      Cell: tableType,
      width: 100,
      resizable: true,
      filterable: false,
      type: 'string',
    },
    type: 'string',
  },
];

export const requestedItemColumns = [
  {
    column: {
      Header: '',
      accessor: 'requestedItemId',
      filterable: false,
      resizable: true,
      width: 50,
      Cell: editRequestedItem,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Request FY #',
      resizable: true,
      accessor: 'requestItemFYNumber',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Barcode',
      resizable: true,
      accessor: 'barcode',
      type: 'string',
    },
    type: 'string',
  },
  // {
  //   column: {
  //     Header: 'Asset #',
  //     accessor: 'assetNumber',
  //     type: 'string',
  //   },
  //   type: 'string',
  // },
  {
    column: {
      Header: 'Serial Number',
      resizable: true,
      accessor: 'serialNumber',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Department',
      accessor: 'department',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Delivery Date',
      resizable: true,
      accessor: 'deliveryDate',
      Cell: (props: any) => (props.value == null ? '' : moment(props.value, 'YYYY-MM-DD HH:mm Z').format('MM/DD/YYYY h:mm a')),
    },
    type: 'Date',
  },
  // {
  //   column: {
  //     Header: 'EOne Entry Date',
  //     accessor: 'dateEnteredInEnterpriseOne',
  //     Cell: (props: any) => (props.value == null ? '' : moment(props.value, 'YYYY-MM-DD HH:mm Z').format('MM/DD/YYYY h:mm a')),
  //   },
  //   type: 'Date',
  // },
  {
    column: {
      Header: 'Description 1',
      accessor: 'description1',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 2',
      resizable: true,
      accessor: 'description2',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 3',
      resizable: true,
      accessor: 'description3',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Status',
      resizable: true,
      accessor: 'status',
      type: 'string',
    },
    type: 'string',
  },
];

export const reqEoneReadyColumns = [
  {
    column: {
      Header: '',
      accessor: 'requestedItemId',
      filterable: false,
      resizable: true,
      Cell: editRequestedItem,
      width: 50,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Asset #',
      resizable: true,
      accessor: 'assetNumber',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Barcode',
      resizable: true,
      accessor: 'barCode',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 1',
      resizable: true,
      accessor: 'description1',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 2',
      accessor: 'description2',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 3',
      resizable: true,
      accessor: 'description3',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Status',
      resizable: true,
      accessor: 'status',
      type: 'string',
    },
    type: 'string',
  }
];

export const eOneColumns = [
  {
    column: {
      Header: '',
      accessor: 'updateId',
      resizable: true,
      type: 'string',
      Cell: editEOneItem,
      width: 50,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Asset #',
      resizable: true,
      accessor: 'assetNumber',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Barcode',
      resizable: true,
      accessor: 'barCode',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 1',
      resizable: true,
      accessor: 'description1',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 2',
      accessor: 'description2',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 3',
      resizable: true,
      accessor: 'description3',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Update Status',
      resizable: true,
      accessor: 'updateStatus',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Update Type',
      resizable: true,
      accessor: 'updateType',
      Cell: updateType,
      type: 'string',
      width: 110,
    },
    type: 'string',
  },
];

/** Filter Buttons */
export const filterButtonsReqItem = [
  new FilterButtons('Requested', 'info', [
    {
      id: 'status',
      type: 'string',
      operand: 'and',
      isLike: false,
      value: 'Requested',
    },
  ]),
  new FilterButtons('Ordered', 'info', [
    {
      id: 'status',
      type: 'string',
      operand: 'and',
      isLike: false,
      value: 'Ordered',
    },
  ]),
  new FilterButtons('Barcoded', 'info', [
    {
      id: 'status',
      type: 'string',
      operand: 'and',
      isLike: false,
      value: 'Barcoded',
    },
  ]),
  new FilterButtons('Ready for EOne', 'info', [
    {
      id: 'status',
      type: 'string',
      operand: 'and',
      isLike: false,
      value: 'Ready for EOne',
    },
  ]),
  new FilterButtons('Pull From Stock', 'info', [
    {
      id: 'status',
      type: 'string',
      operand: 'and',
      isLike: false,
      value: 'Pull From Stock',
    },
    {
      id: 'status',
      type: 'string',
      operand: 'or',
      isLike: true,
      value: '%Transfers',
    },
  ]),
  new FilterButtons('Complete', 'info', [
    {
      id: 'status',
      type: 'string',
      operand: 'and',
      isLike: false,
      value: 'Complete',
    },
  ]),
  new FilterButtons('Exported', 'info', [
    {
      id: 'status',
      type: 'string',
      operand: 'and',
      isLike: false,
      value: 'Exported to EOne',
    },
  ]),
  new FilterButtons('Show All', 'primary', null),
];

export const filterButtonsEOne = [
  new FilterButtons('Ready for EOne', 'info', {
    id: 'updateStatus',
    type: 'string',
    operand: 'and',
    isLike: false,
    value: 'Ready For EOne',
  }),
  new FilterButtons('Success', 'info', {
    id: 'updateStatus',
    type: 'string',
    operand: 'and',
    isLike: false,
    value: 'Import Successful',
  }),
  new FilterButtons('Export Errors', 'info', {
    id: 'updateStatus',
    type: 'string',
    operand: 'and',
    isLike: true,
    value: 'Error',
  }),

  // new FilterButtons('Transfers', 'info', {
  //   id: 'updateStatus',
  //   type: 'string',
  //   operand: 'and',
  //   isLike: true,
  //   value: 'Transfer',
  // }),
  new FilterButtons('Show All', 'primary', null),
];
